// Package imports:
import React from 'react';
// Component imports:
import Entrypoint from '../Entrypoint';
import CompanySubPage from '../../components/Company/CompanySubPage/CompanySubPage';
import CompanyCompareChooseComp from '../../components/Company/CompanyCompare/CompanyCompareChoose';
// Type imports:
import { ICompanyViewModel } from '../../types/CompanyTypes';

const CompanyCompareChoose: React.FC<ICompanyViewModel> = ({
    id,
    isAuthenticated,
    isSubscriber
}) => {
    return (
        <Entrypoint>
            <CompanySubPage 
                id={id}
                noAd
                title='Samanburður'
                isAuthenticated={isAuthenticated}
                isSubscriber={isSubscriber}
                component={
                    <CompanyCompareChooseComp id={id} isAuthenticated={isAuthenticated} isSubscriber={isSubscriber} />
                } 
            />
        </Entrypoint>
    );
}

export default CompanyCompareChoose;